import React from "react";

const ErrorIcon = () => {
  return (
    <div className="flex-shrink-0 flex items-center justify-center w-[20px] h-[20px] rounded-full bg-red-500 mr-2">
      <svg xmlns="http://www.w3.org/2000/svg" width={4} height={14}>
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M3.198 9.369H.789c-.247 0-.443-.143-.443-.325L.125.958c0-.092.04-.183.13-.235A.501.501 0 0 1 .568.62h2.864c.117 0 .235.04.313.104.09.052.13.143.13.235l-.234 8.086c-.013.182-.209.325-.443.325Zm.065 4.583h-2.5a.434.434 0 0 1-.43-.43V11.05c0-.235.196-.43.43-.43h2.5c.221 0 .404.195.404.43v2.474c0 .234-.183.43-.404.43Z"
        />
      </svg>
    </div>
  );
};

export default ErrorIcon;
